import { getFeatureFlags } from 'adminPanel/api/featureFlags';
import { FeatureFlag } from 'adminPanel/types';
import { useEffect, useState } from 'react';

export const useFeatureFlags = () => {
    const [featureFlags, setFeatureFlags] = useState<FeatureFlag[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getFeatureFlags()
            .then(setFeatureFlags)
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const refetch = () => {
        getFeatureFlags()
            .then(setFeatureFlags)
            .finally(() => {
                setIsLoading(false);
            });
    };

    return { featureFlags, isLoading, refetch };
};
